// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pxGzPsWab2Mj28eFigIK{flex-direction:column;display:flex}.pxGzPsWab2Mj28eFigIK.MoeLxEWpsDQmLDnsl5dK{flex-flow:column-reverse}.vAsLvH0dOj8EFVmHwbC6{flex-direction:row;padding:4px;display:flex}.BhnAaitcrFQ60X7dRMuJ{background-color:var(--border-neutral-default);width:100%;height:1px}.USuNvRmxvkUL_68vCcds{flex:1}.Mcaa9J0o4U0lyzYzTuSA{flex-direction:column;gap:2px;height:224px;padding:4px;display:flex;overflow:auto}.L2E3lEX68WIWxGBiMzC_{align-items:center;gap:12px;width:100%;height:48px;padding:8px 12px;display:flex}.L2E3lEX68WIWxGBiMzC_ .Jm1MR3W7AiAf8yLxIyRE{flex-direction:column;align-items:flex-start;gap:2px;display:flex}.bbJOd_Pc41wyuJGjnR0n{color:var(--gray-60);justify-content:center;align-items:center;height:100%;padding:8.5px 0;font-size:12px;font-weight:400;line-height:15px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `pxGzPsWab2Mj28eFigIK`,
	"reverse": `MoeLxEWpsDQmLDnsl5dK`,
	"header": `vAsLvH0dOj8EFVmHwbC6`,
	"divider": `BhnAaitcrFQ60X7dRMuJ`,
	"textField": `USuNvRmxvkUL_68vCcds`,
	"wrapItems": `Mcaa9J0o4U0lyzYzTuSA`,
	"mockItem": `L2E3lEX68WIWxGBiMzC_`,
	"content": `Jm1MR3W7AiAf8yLxIyRE`,
	"noResult": `bbJOd_Pc41wyuJGjnR0n`
};
export default ___CSS_LOADER_EXPORT___;
